<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid appt-list-page-container"
    >
      <div>
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mb-1">
              {{ "appoinmentList" | translate }}
            </h3>
          </div>

          <div
            [hidden]="isLoading || appointmentCards.length === 0"
            class="d-flex align-items-center gap-3"
          >
            <!-- Filter btn -->
            <button
              class="btn btn-icon btn-active-light-primary cursor-pointer"
              (mouseenter)="showTooltip($event, 'filter')"
              (mouseleave)="hideTooltip()"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFilters"
              aria-expanded="false"
              aria-controls="collapseFilters"
            >
              <i class="fa-solid fa-filter"></i>
            </button>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>
          </div>
        </div>

        <!-- FILTERS -->
        <div>
          <div class="collapse mb-8" id="collapseFilters">
            <form (ngSubmit)="getAppointmentList(1, pageSize, filterForm)">
              <div class="row align-items-end">
                <!-- Patient Name -->
                <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                  <label class="form-label fs-14">
                    {{ "patientNameSurname" | translate }}
                  </label>
                  <input
                    [(ngModel)]="filterForm.patientName"
                    name="patientName"
                    type="text"
                    class="form-control fs-14"
                    [placeholder]="'filterByNameAndSurname' | translate"
                  />
                </div>

                <!-- PID -->
                <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                  <label class="form-label fs-14">
                    {{ "pid" | translate }}
                  </label>
                  <input
                    [(ngModel)]="filterForm.bsnNumber"
                    name="bsnNumber"
                    type="text"
                    class="form-control fs-14"
                    [placeholder]="'filterByPID' | translate"
                  />
                </div>

                <!-- Date -->
                <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                  <label class="form-label fs-14">
                    {{ "date" | translate }}
                  </label>
                  <input
                    [(ngModel)]="filterForm.date"
                    name="date"
                    type="date"
                    class="form-control fs-14"
                    max="9999-12-31"
                    (input)="validateDateInput($event)"
                  />
                </div>

                <!-- Buttons -->
                <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                  <div class="d-flex justify-content-start gap-4">
                    <button
                      type="button"
                      class="btn btn-secondary cursor-pointer fs-14 flex-grow-1"
                      (click)="clearFilters()"
                    >
                      {{ "clear" | translate }}
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary cursor-pointer fs-14 flex-grow-1"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- LIST CONTAINER -->
        <div>
          <!-- Loading -->
          <div *ngIf="isLoading" class="d-flex justify-content-center pb-4">
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>

          <!-- Empty state -->
          <div
            *ngIf="!isLoading && appointmentCards.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "noAppointments" | translate }}
          </div>

          <!-- GRID HEADER -->
          <div
            class="grid-header"
            *ngIf="
              columns.length > 0 && !isLoading && appointmentCards.length > 0
            "
          >
            <ng-container *ngFor="let col of columns">
              <div
                [ngClass]="getColClass(col)"
                (click)="
                  ['CreatedDate', 'Patient', 'Status', 'Role'].includes(col.key)
                    ? onSort(
                        col.key === 'Patient'
                          ? 'patientName'
                          : col.key === 'CreatedDate'
                            ? 'createdDate'
                            : col.key === 'Role'
                              ? 'createdBy'
                              : 'status'
                      )
                    : null
                "
                [class.cursor-pointer]="
                  ['CreatedDate', 'Patient', 'Status', 'Role'].includes(col.key)
                "
              >
                {{ col.labelKey | translate }}
                <ng-container
                  *ngIf="
                    (filterForm.sortBy === 'createdDate' &&
                      col.key === 'CreatedDate') ||
                    (filterForm.sortBy === 'patientName' &&
                      col.key === 'Patient') ||
                    (filterForm.sortBy === 'status' && col.key === 'Status') ||
                    (filterForm.sortBy === 'createdBy' && col.key === 'Role')
                  "
                >
                  <i
                    class="fa-solid ms-1"
                    style="font-size: 0.65em !important; vertical-align: middle"
                    [ngClass]="{
                      'fa-chevron-down': filterForm.sortDirection === 'desc',
                      'fa-chevron-up': filterForm.sortDirection === 'asc',
                    }"
                  ></i>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <!-- CARD LIST -->
          <ng-container *ngIf="!isLoading && appointmentCards.length > 0">
            <app-list-card
              *ngFor="let card of appointmentCards"
              [item]="card"
              [columns]="columns"
              (cardClick)="onCardClick(card)"
            >
            </app-list-card>
          </ng-container>
        </div>

        <!-- PAGINATION -->
        <div
          class="d-flex flex-stack flex-wrap pt-10"
          *ngIf="totalCount > 0 && !isLoading && appointmentCards.length > 0"
        >
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center gap-2">
              <label class="me-2 fs-6 fw-semibold text-gray-700">
                {{ "pageSize" | translate }}:
              </label>
              <app-page-size-selector
                [sizes]="pageSizes"
                [selectedSize]="pageSize"
                (sizeChange)="changePageSize($event)"
              >
              </app-page-size-selector>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              {{ "showing" | translate }} {{ appointments.length }}
              {{ "of" | translate }} {{ totalCount }}
              {{ "appointments" | translate }}
            </div>
          </div>

          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>

            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>

            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
